<!-- status content start-->
<ion-grid class="ion-no-padding ion-margin-bottom">
  <ion-row>
    <ion-col class="ion-no-padding">
      <div class="panel-border">
        <ion-row>
          <ion-col class="ion-text-center ion-margin-top ion-margin-bottom">
            <ion-label
              class="panel-label-text"
              [innerHTML]="switchView()"
            ></ion-label>
          </ion-col>
        </ion-row>
        @if (canShowButton()) {
          <ion-row>
            <ion-col class="ion-text-center ion-margin-bottom">
              <ion-button
                [disabled]="shouldDisableForm()"
                (click)="menuItemClick(routeName())"
                class="panel-label-text ion-wrap ion-align-self-center"
                color="primary"
              >
                <ion-label class="panel-label-text">
                  <small>{{ 'installation_addOwner' | translate }}</small>
                </ion-label>
              </ion-button>
            </ion-col>
          </ion-row>
        }
      </div>
    </ion-col>
  </ion-row>
</ion-grid>
<!-- status content end-->
